import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { ProbationContractScreen } from '@/features/hr-reports/probation-contract-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/hr/reports/probation-contract')({
  validateSearch: (search: Record<string, unknown>) => hrReportSearchFrom(search),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: ProbationContractScreenRoute,
})

function ProbationContractScreenRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <ProbationContractScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/hr/reports/probation-contract', search: next })
      }
    />
  )
}
